export default __webpack_public_path__ + "static/media/job.54051762.gif";